// extracted by mini-css-extract-plugin
export var equalColumn = "_je-0";